(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('last-name', {
            parent: 'entity',
            url: '/last-name?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.lastName.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/last-name/last-names.html',
                    controller: 'LastNameController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('lastName');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('last-name-detail', {
            parent: 'entity',
            url: '/last-name/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.lastName.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/last-name/last-name-detail.html',
                    controller: 'LastNameDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('lastName');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'LastName', function($stateParams, LastName) {
                    return LastName.get({id : $stateParams.id});
                }]
            }
        })
        .state('last-name.new', {
            parent: 'last-name',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/last-name/last-name-dialog.html',
                    controller: 'LastNameDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('last-name', null, { reload: true });
                }, function() {
                    $state.go('last-name');
                });
            }]
        })
        .state('last-name.edit', {
            parent: 'last-name',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/last-name/last-name-dialog.html',
                    controller: 'LastNameDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['LastName', function(LastName) {
                            return LastName.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('last-name', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('last-name.delete', {
            parent: 'last-name',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/last-name/last-name-delete-dialog.html',
                    controller: 'LastNameDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['LastName', function(LastName) {
                            return LastName.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('last-name', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
